import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { parseDealsDashboardStats } from "@/lib/deals-dashboard-stats-parse";
import type { DealDashboardStats } from "@/types/deal";

export interface DealsStatsDateRange {
  from: Date;
  to: Date;
}

const STATS_STALE_MS = 3 * 60 * 1000;

/**
 * @param queryEnabled Quando false, não chama a RPC (ex.: painel de métricas fechado — economiza o banco).
 */
export function useDealsDashboardStats(
  workspaceId: string | null,
  range: DealsStatsDateRange,
  queryEnabled = true,
) {
  const fromISO = range.from.toISOString();
  const toISO = range.to.toISOString();

  return useQuery({
    queryKey: ["deals-dashboard-stats", workspaceId, fromISO, toISO] as const,
    queryFn: async (): Promise<DealDashboardStats> => {
      if (!workspaceId) {
        throw new Error("workspaceId ausente");
      }
      const { data, error } = await supabase.rpc("get_deals_dashboard_stats", {
        p_workspace_id: workspaceId,
        p_date_from: fromISO,
        p_date_to: toISO,
      });
      if (error) throw error;
      return parseDealsDashboardStats(data);
    },
    enabled: !!workspaceId && queryEnabled,
    staleTime: STATS_STALE_MS,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 1,
  });
}
